export const mutations = {
  MutationPrivateFileLoadingStatus(state, status) {
    state.privateFileLoadingStatus = status;
  },
};
